import { render, staticRenderFns } from "./LightCandleNav.vue?vue&type=template&id=fa85635a&scoped=true&"
import script from "./LightCandleNav.vue?vue&type=script&lang=js&"
export * from "./LightCandleNav.vue?vue&type=script&lang=js&"
import style0 from "./LightCandleNav.vue?vue&type=style&index=0&id=fa85635a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa85635a",
  null
  
)

export default component.exports